import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    {
        path: 'home',
        loadComponent: () => import('./home/home.component').then(c => c.HomeComponent),
        canActivate: [MsalGuard]
    },
    {
        path: 'projects',
        loadComponent: () => import('./projects/project-listing.component').then(c => c.ProjectListingComponent),
        canActivate: [MsalGuard]
    },
    {
        // The whole project-detail subtree (and its NGXS states) is lazy-loaded via loadChildren so
        // TemplatesState / JobsState / StatisticsState and the two can-deactivate guards stay out of
        // the eager main bundle; the detail shell is the subtree's own path:'' component.
        path: 'projects/:projectId',
        canActivate: [MsalGuard],
        loadChildren: () => import('./projects/project-detail/project-detail.routes').then(r => r.projectDetailRoutes)
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(m => m.adminRoutes)
    },
    {
        path: 'unauthorized',
        loadComponent: () =>
            import('./auth/components/unauthorized/unauthorized.component').then(c => c.UnauthorizedComponent)
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'not-found',
        loadComponent: () => import('./shared/components/not-found/not-found.component').then(c => c.NotFoundComponent)
    },
    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];
